export const InputStyle = {
	height: "40px",
	width: "100%",
	marginBottom: "10px",
};
